import React from "react";
import PropTypes from "prop-types";

import styles from "./ModalGallery.scss";

function GalleryIframe({
  src,
  title,
  width,
  height,
  allow,
  allowFullScreen,
  wrapperProps,
  ...props
}) {
  return (
    <div className={styles["iframe-container"]} {...wrapperProps}>
      <iframe
        src={src}
        className={styles.iframe}
        title={title}
        width={width}
        height={height}
        allow={allow}
        allowFullScreen={allowFullScreen}
        {...props}
      />
    </div>
  );
}

GalleryIframe.propTypes = {
  wrapperProps: PropTypes.objectOf(PropTypes.any),
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  allowFullScreen: PropTypes.bool,
  allow: PropTypes.string,
};

GalleryIframe.defaultProps = {
  wrapperProps: null,
  width: "100%",
  height: "100%",
  allowFullScreen: false,
  allow: null,
};

GalleryIframe.displayName = "ModalGallery.Iframe";

export default GalleryIframe;
